import { REPORT_BUILDER_PATH_NAME } from '../constant/headerMenuItems'

export const getURLHelper = (link, prefix = '')  => {
  try {
    const url = new URL(link);
    if (url.protocol === "http:" || url.protocol === "https:") {
      if(link.includes(REPORT_BUILDER_PATH_NAME)){
        // if report url avoid default url redirection
        return '#';
      }else{
        return link;
      }
    }
  } catch (error) {}
  let processedLink = link ? link.replace(/ /g, '-') : "";
  
  if (processedLink && processedLink !== "" && processedLink[0] === "/") {
    return prefix + processedLink;
  } else if (prefix !== "") {
    return (prefix + "/" + (processedLink ? processedLink : ""))
  } else {
    return processedLink ?? "";
  }
}

export const getProductCatUrl = (link) => {
  return getURLHelper(link, '/products');
}
